export default "__VITE_ASSET__fc19b3ed__"